import { FaqPage } from './faqPage';

const props = [];

export const FaqPageDirective = reactDirective => reactDirective(FaqPage, props);
FaqPageDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('faqPage', FaqPageDirective);
